import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import './TabNav.css';

class TabNav extends Component {
  _isMounted = false;

  constructor(props){
    super(props);

  }


  componentDidUpdate(){

  }

  render(){
    let classList = "";

    if(this.props.vertical){
      classList += " tab-nav-vertical";
    } else {
      classList += " tab-nav-horizontal";
    }

    if(this.props.selectedStaysLit || this.props.vertical){
      classList += " tab-nav-selected-stays-lit";
    }

    if(this.props.grow){
      classList += " tab-nav-grow";
    } 

    if(this.props.style){
      classList += " tab-nav-style-" + this.props.style;
    }

    if(!this.props.bordered){
      classList += " tab-nav-borderless";
    } 

    if(this.props.theme){
      classList += " tab-nav-theme-" + this.props.theme;
    }

    if(this.props.stretched){
      classList += " tab-nav-stretched";
    }

    return <div className={"tab-nav " + classList}>
      {
        this.props.items.map((item, i)=>{

          if(item.hideIf) return;

          let itemClassList = "tab-nav-item";
          if(this.props.value === item.value) itemClassList += " tab-nav-item-selected";
          if(item.disabled) itemClassList += " tab-nav-item-disabled";

          if(this.props.vertical){
            return <div 
              key={i} 
              className={itemClassList}
              onMouseEnter={e => {
                if(item.onMouseEnter) item.onMouseEnter(e);
              }}
              onMouseLeave={e => {
                if(item.onMouseLeave) item.onMouseLeave(e);
              }}
              onClick={()=>{
                this.props.onChange(item.value);
              }}
              >
              <nobr className="list-left list-left-no-wrap">
                {
                  item.autoIcon &&
                  <i className={item.autoIcon + " fa-fw tab-nav-item-icon"}/>
                }
                <span className="text-ellipsis no-margin-right tab-nav-item-text">{item.display}</span>
              </nobr>
            </div>
          }
          return <div 
            key={i} 
            className={itemClassList}
            onMouseEnter={e => {
              if(item.onMouseEnter) item.onMouseEnter(e);
            }}
            onMouseLeave={e => {
              if(item.onMouseLeave) item.onMouseLeave(e);
            }}
            onClick={()=>{
              this.props.onChange(item.value);
            }}
            >
            <nobr className="list-left list-left-no-wrap tab-nav-item-width-setter">
              {
                item.autoIcon &&
                <i className={item.autoIcon + " fa-fw tab-nav-item-icon"}/>
              }
              <span className="text-ellipsis no-margin-right tab-nav-item-text">{item.display}</span>
            </nobr>
            <nobr className="list-left list-left-no-wrap tab-nav-item-display">
              {
                item.autoIcon &&
                <i className={item.autoIcon + " fa-fw tab-nav-item-icon"}/>
              }
              <span className="text-ellipsis no-margin-right tab-nav-item-text">{item.display}</span>
            </nobr>
          </div>
        })
      }
    </div>
  }
};

export default TabNav;